<template>
  <div class="App-wrapper">
    <Header v-if="!layoutMeta.hideHeader" />

    <main :class="['App-main', layoutMeta.mainClasses]">
      <router-view v-slot="{ Component, route: currentRoute }">
        <!-- Wrapper required: out-in must animate a keyed DOM node, not a dynamic component root -->
        <Transition
          mode="out-in"
          name="fade"
          @after-leave="syncLayoutWithRoute"
          @after-enter="syncLayoutWithRoute"
        >
          <div
            :key="currentRoute.fullPath"
            class="App-route-view"
          >
            <component :is="Component" />
          </div>
        </Transition>
      </router-view>
    </main>

    <Aside v-if="!layoutMeta.hideAside" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { useRoute } from 'vue-router';

import Header from '@/skeleton/Header/Header.vue';
import Aside from '@/skeleton/Aside/Aside.vue';

const route = useRoute();

// Keep chrome from the outgoing view until the fade finishes. Route meta
// updates immediately, which would otherwise collapse header/aside while
// the previous page is still on screen (e.g. cluster list → create).
const layoutMeta = ref({
  hideHeader: route.meta.hideHeader,
  hideAside: route.meta.hideAside,
  mainClasses: route.meta.mainClasses,
});

function syncLayoutWithRoute() {
  layoutMeta.value = {
    hideHeader: route.meta.hideHeader,
    hideAside: route.meta.hideAside,
    mainClasses: route.meta.mainClasses,
  };
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.App-route-view {
  width: 100%;
}
.App-main__height-full .App-route-view {
  height: 100%;
}
</style>
